"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsubscribeReasons = void 0;
var UnsubscribeReasons;
(function (UnsubscribeReasons) {
    UnsubscribeReasons["I_DONT_REMEMBER"] = "I don\u2019t remember signing up for Tenderd emails";
    UnsubscribeReasons["NO_LONGER_INTERESTED"] = "I am no longer interested in what Tenderd has to offer";
    UnsubscribeReasons["TOO_MANY_EMAILS"] = "I receive too many emails from Tenderd";
    UnsubscribeReasons["I_DONT_WORK_IN_THE_INDUSTRY"] = "I don\u2019t work in the Construction industry anymore";
    UnsubscribeReasons["OTHER"] = "Other";
})(UnsubscribeReasons = exports.UnsubscribeReasons || (exports.UnsubscribeReasons = {}));
//# sourceMappingURL=suppression.js.map